import { render, staticRenderFns } from "./LocationAssignments.vue?vue&type=template&id=1ffb2578&scoped=true"
import script from "./LocationAssignments.vue?vue&type=script&lang=ts"
export * from "./LocationAssignments.vue?vue&type=script&lang=ts"
import style0 from "./LocationAssignments.vue?vue&type=style&index=0&id=1ffb2578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb2578",
  null
  
)

export default component.exports